/*
 * @FilePath     : /es-package/packages/es-mpx-usex/index.js
 * @Author       : LiYang
 * @Date         : 2022-01-11 19:00:28
 * @LastEditTime: 2023-03-22 11:37:59
 * @LastEditors: showangjing showangjing@didiglobal.com
 * @Description  :
 */
import  { getStore } from './lib/store'
export { response as relog, request,closeMask } from './lib/plugin'
export { default as pre } from './lib/pre'
export { getStore }
export { default as getEnv } from './lib/env'


export default (app) => {
  app.mixin(
    {
      globalStore: getStore(),
    },
    {
      types: 'app'
    }
  )
}
